export default __webpack_public_path__ + "static/media/(7).df3a4277.jpeg";